"use strict"

jQuery(function($) {
	if ($('.conference-page').length) {
		var href = jQuery("a"),
		 	querystring = '?pledge=1';

		href.each(function(){
			var href = jQuery(this).attr('href');
			if (href) {
				$(this).attr('href', href + querystring);
			}
		});
    }
 
	if ($('.pledge-single-post').length) {
		var pathName = document.location.protocol +"//"+ document.location.hostname + document.location.pathname,
			$body = jQuery("body"),
			url = '',
			$btnNextArticle = jQuery('#next-article'),
		    pledgePosts = localStorage.getItem('pledgePosts').split(","),
			arrayLength = pledgePosts.length;

			$body.addClass('pledge-header');

		for (var i = 0; i < arrayLength; i++) {
			url = pledgePosts[i].replace(/\"/g, "");

			if (url === pathName) {
				if (i !== arrayLength-2) {
					$btnNextArticle.attr('href', pledgePosts[i+1].replace(/\"/g, "")+'?pledge=1');
					break;
				} else {
					$btnNextArticle.attr('href', pledgePosts[0].replace(/\"/g, "")+'?pledge=1');
					break;
				}
			}

		}

		// Sticky menu on Tablet and desktop
		var $window = jQuery(window),
			$document = $(document),
			$sidebar = jQuery('.single-sidebar'),
			$pledgeNavWrapper = jQuery('.pledge-nav-wrapper'),
			$pledgesSingleContent = jQuery('section.entry-content');
			
		jQuery(window).on("resize", function(){
			stickyNav();
			$sidebar.css("height", $pledgesSingleContent.innerHeight()+"px");
			if ($window.width() < 768) {
				$pledgeNavWrapper.css("margin-top", "0px");
				$sidebar.css("height", "100%");
			}
		}).resize();
		
		jQuery(window).on("scroll", function(){
			stickyNav();
		});
	}

	// Sign-up form for Mailchimp
	if ($('.beccs-mailchimp-api').length) {
		var $form = jQuery("#mcEmbeddedSubscribeForm"),
			$btnSubmit = jQuery(".mcBtn-form-submit"),
			$mcSuccessResponse = jQuery(".mc-success-response"),
			$mcErrorResponse = jQuery(".mc-error-response"),
			$email = jQuery("#mceEMAIL");

		if ( $form.length > 0 ) {
			$('form input[type="submit"]').bind('click', function ( event ) {
				if ( event ) event.preventDefault();
				var emailVal = $email.val();

				// validate email
				if ( validateEmail( emailVal ) ) {
					$mcErrorResponse.attr("style", "display:none;");
					$btnSubmit.attr("style", "display:block;");
					register($form, $email, $btnSubmit, $mcSuccessResponse);
				} else {
					$btnSubmit.attr("style", "display:none;");
					$mcErrorResponse.attr("style", "display:block;");
					$email.val('The e-mail is invalid.');
					$email.attr("style", "color:#d22f19;");
				}
			});

			// Check email
			$($email).on('focus', function () {
				$btnSubmit.attr("style", "display:block;");
				$mcErrorResponse.attr("style", "display:none;");
				$email.val('');
				$email.attr("style", "color:#c7d3dd;");
			});
		}
	}

	function stickyNav() {
		var width = $window.width(),
			height = $window.height() / 2,
			scrollPos = $document.scrollTop(),
			sidebarOffsetTop = $sidebar.offset().top,
			sidebarOffsetTopAndBottom = ($sidebar.offset().top + $sidebar.innerHeight()) - $pledgeNavWrapper.innerHeight(),
			topTrigerPoint = scrollPos + height;

		if ( width >= 768 && sidebarOffsetTop < topTrigerPoint && sidebarOffsetTopAndBottom > topTrigerPoint ) {
			$pledgeNavWrapper.css("margin-top", (topTrigerPoint - sidebarOffsetTop)+"px");
		}
	}

	// Register function is used to send the data to Mailchimp API
	function register($form, $email, $btnSubmit, $mcSuccessResponse) {
		$.ajax({
			type: $form.attr('method'),
			url: $form.attr('action'),
			data: $form.serialize(),
			cache       : false,
			dataType    : 'json',
			contentType: "application/json; charset=utf-8",
			error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
			success     : function(data) {
				if (data.result != "success") {
					// Something went wrong, do something to notify the user. maybe alert(data.msg);
					$email.val('Success!');
					$email.attr("style", "color:#fff;background: #246ef3; border: solid 1px #fff;");
					$email.attr("disabled", "disabled");
					$btnSubmit.attr("style", "display:none;");
					$mcSuccessResponse.attr("style", "display:block;");
				} else {
					// Success
					$email.val('Success!');
					$email.attr("style", "color:#fff;background: #246ef3; border: solid 1px #fff;");
					$email.attr("disabled", "disabled");
					$btnSubmit.attr("style", "display:none;");
					$mcSuccessResponse.attr("style", "display:block;");
				}
			}
		});
	}

	function validateEmail(emailVal) {
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(emailVal);
	}
});